import { has, isNil, round, isString, startsWith } from 'lodash';

export function formatNumberForEdit({
  value,
  multiplier = 1,
  decimalSeparator = '.',
  valuePrecision = 4,
}) {
  if (isNil(value)) return '';

  const scaledValue = round(value * multiplier, valuePrecision);

  return decimalSeparator === ','
    ? scaledValue.toString().replace('.', ',')
    : scaledValue.toString();
}

export function parseEditedNumber({
  value,
  multiplier = 1,
  decimalSeparator = '.',
  emptyValue = null,
  valuePrecision = 4,
}) {
  if (value === '') {
    return emptyValue;
  }

  if (!isString(value)) {
    return Number.isFinite(value) ? round(value, valuePrecision) : value;
  }

  const hasLocalSeparator = isString(value) && value.includes(decimalSeparator);
  const minusSign = startsWith(value, '-') ? '-' : '';

  if (hasLocalSeparator) {
    const ix = value.lastIndexOf(decimalSeparator);
    const left = value.slice(0, ix).replace(/\D/g, '');
    const right = value.slice(ix + decimalSeparator.length).replace(/\D/g, '');

    value = `${minusSign}${left}.${right}`;
  }

  const parsed = parseFloat(value);

  if (Number.isNaN(parsed)) {
    return null;
  }

  const output = round(parsed / multiplier, valuePrecision);

  return output;
}

export function isValidCharacter({ key, currentValue, selectionStart, decimalSeparator }) {
  if (key === decimalSeparator && currentValue.includes(decimalSeparator)) {
    return false;
  }

  if (key === '-' && selectionStart !== 0) {
    return false;
  }

  const regex = decimalSeparator === '.' ? /^[0-9.-]$/ : /^[0-9,-]$/;

  return regex.test(key);
}

export function createValueFormatter({ formatter, displayPrecision, multiplier }) {
  const format = displayPrecision === 0 ? '0,0' : `0,0.${'0'.repeat(displayPrecision)}`;

  return params => {
    let value = params;

    const isCellEdit = has(value, 'value', false);

    if (isCellEdit) {
      value = value.value;
    }

    if (isNil(value) || value === '') {
      return '';
    }

    const displayValue = isCellEdit ? round(value * multiplier, displayPrecision) : value;

    return formatter.format(displayValue, format);
  };
}
